import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';

export const ModalDocDLConfirmId = 'ModalDocDLConfirm';

const ModalDocDLConfirm = ({ mediaIsPhone, modalClose, onClick, onClickAlt }) => {
  const scrollableAreaRef = useRef(null);

  return (
    <Modal
      title="Download"
      modalId={ModalDocDLConfirmId}
      scrollableAreaRef={scrollableAreaRef}
      compact
    >
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{ maxWidth: '612px' }}
      >
        <Text type="b4" mb={48}>
          Sono consapevole che questo documento è di proprietà del Gruppo SISFOR. Dichiaro di utilizzarlo esclusivamente per fini formativi SISFOR e di non divulgarlo a terzi.
        </Text>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="accetta e scarica"
          fullsize={mediaIsPhone}
          onClick={() => {
            onClick && onClick();
            onClickAlt && onClickAlt();
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalDocDLConfirm.propTypes = {
  onClick: PropTypes.func,
  onClickAlt: PropTypes.func,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state

  // dispatch
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { onClickAlt } = state.app.modal.payload;
      return { onClickAlt };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
    })
  ),
  withMediaQueries
)(ModalDocDLConfirm);
